var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0004 1.66669V3.33335M4.00037 1.66669V3.33335",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.08371 10.2027C1.08371 6.57161 1.08371 4.75607 2.12714 3.62803C3.17057 2.5 4.84995 2.5 8.20871 2.5H9.79204C13.1508 2.5 14.8302 2.5 15.8736 3.62803C16.917 4.75607 16.917 6.57161 16.917 10.2027V10.6306C16.917 14.2617 16.917 16.0773 15.8736 17.2053C14.8302 18.3333 13.1508 18.3333 9.79204 18.3333H8.20871C4.84995 18.3333 3.17057 18.3333 2.12714 17.2053C1.08371 16.0773 1.08371 14.2617 1.08371 10.6306V10.2027Z",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4046",
    d: "M1.50037 6.66669H16.5004",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.41b191562e8e82240fdfd2256c59c909.svg";
export { ForwardRef as ReactComponent };